"use client"
import Image from "next/image";
import React from "react";

export default function Card({ href, src, name }: {href: string; src: string, name: string}) {
    return (
        <a
            className='flex justify-center items-center cursor-pointer transition-all duration-short rounded-2xl overflow-hidden w-140 h-80 hover:scale-110 shadow-lg bg-cover bg-no-repeat bg-center select-none'
            href={href}
            style={{
                    backgroundImage: `linear-gradient(
      rgba(34, 34, 34, 0.6),
      rgba(34, 34, 34, 0.6)
    ), url(${src})`}} >
            <h1 className="text-5xl text-gray-100">{name}</h1>
        </a>
    )
}